import React, {useContext, useState} from 'react'
import './PasswordForm.css'
import {AppContext} from '../App'

type Props = {
  errors: string[]
}
export default function PasswordForm(props: Props) {
  const message = ((errors) => {
    if (errors.length > 0) {
      return (
        <>
          { errors.map((msg, index) => {
            return (
              <p key={index} className="error">{msg}</p>
            )
          })}
        </>
      )
    } else {
      return <p>ストーリーを見るには「あいことば」が必要です</p>
    }

  })(props.errors)
  const { app, setApp } = useContext(AppContext)
  const [pw, setPw] = useState(app?.password)
  const handleChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    setPw(ev.target.value)
  }
  const handleClick = (ev: React.FormEvent<HTMLButtonElement>) => {
    ev.preventDefault()
    ev.stopPropagation()
    // const el = ev.currentTarget
    // el.setAttribute('disabled', 'disabled')
    // App で管理してる state の操作をしたい
    setApp({ ...app, password: pw })
  }

  return (
    <form>
      {message}
      <input type="text" placeholder="あいことば" value={pw} onChange={handleChange} />
      <button onClick={handleClick}>あいことばを入力する</button>
    </form>
  )
}
